import type { TSurveyQuestion } from "@/types"
import { valueToThemeColor } from "../utils"

export const getChoicesByBinaryMask = (source: number) => {
  const choices: number[] = []
  let value = source

  while (value > 0) {
    const pow = Math.floor(Math.log2(value))
    choices.push(pow)
    value -= 2 ** pow
  }

  return choices.reverse()
}

export function useScaleValue(question: TSurveyQuestion, value?: number | null) {
  const { type, meta } = question
  const scaleType = type == "scale" ? meta?.category : type

  const process =
    scaleType == "scale10"
      ? (value: number) => value * 10
      : scaleType == "scale5"
        ? (value: number) => value * 20
        : (value: number) => value

  if (value === null || value === undefined) return { process, color: "gray" }

  value = scaleType == "scale10" ? value / 10 : scaleType == "scale5" ? value / 20 : value
  return {
    value,
    process,
    color: valueToThemeColor(process(value)),
  }
}

export function scaleToValue(value: number, question: TSurveyQuestion) {
  const { type, meta } = question
  const scaleType = type == "scale" ? meta?.category : type

  return scaleType == "scale10" ? value * 10 : scaleType == "scale5" ? value * 20 : value
}

export function valueToScale(value: number, question: TSurveyQuestion) {
  const { type, meta } = question
  const scaleType = type == "scale" ? meta?.category : type

  return scaleType == "scale10" ? value / 10 : scaleType == "scale5" ? value / 20 : value
}
